var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMortarboardWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.08301 8.33333C2.08301 9.73102 10.5152 13.5417 12.4852 13.5417C14.4551 13.5417 22.8874 9.73102 22.8874 8.33333C22.8874 6.93565 14.4551 3.125 12.4852 3.125C10.5152 3.125 2.08301 6.93565 2.08301 8.33333Z",
    stroke: "white",
    strokeWidth: 1.5625,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.24414 11.4583L6.49946 17.3228C6.50457 17.4402 6.51727 17.5578 6.5513 17.6703C6.65647 18.018 6.85033 18.3339 7.14608 18.5462C9.4601 20.2067 15.5108 20.2067 17.8247 18.5462C18.1207 18.3339 18.3144 18.018 18.4196 17.6703C18.4536 17.5578 18.4663 17.4402 18.4715 17.3228L18.7267 11.4583",
    stroke: "white",
    strokeWidth: 1.5625,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M21.3261 9.89581V17.1875M21.3261 17.1875C20.5011 18.694 20.1363 19.5012 19.7658 20.8333C19.6854 21.3073 19.7492 21.5461 20.0759 21.7582C20.2086 21.8444 20.3681 21.875 20.5262 21.875H22.11C22.2784 21.875 22.4483 21.8399 22.5869 21.7443C22.8906 21.5349 22.9687 21.3052 22.8864 20.8333C22.5616 19.5964 22.1479 18.7508 21.3261 17.1875Z",
    stroke: "white",
    strokeWidth: 1.5625,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMortarboardWhite);
export default __webpack_public_path__ + "static/media/mortarboardWhite.cf8cc8abcb1bd248a3fae70423eed392.svg";
export { ForwardRef as ReactComponent };